import { Injectable, computed, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Document } from '@app/modules/core/store/models/document.model';
import { HorizonRatingsFeature } from './horizon-ratings.feature';
import { HorizonRatingsActions } from './horizon-ratings.actions';
import { CategoryRanksForOverview, TopLevelCategoryRanks } from '../../components/horizon-ratings';

@Injectable({ providedIn: 'root' })
export class HorizonRatingsFacade {
  private store = inject(Store);

  readonly selectedOverviewDocument = this.store.selectSignal(HorizonRatingsFeature.selectSelectedOverviewDocument);
  readonly topLevelCategories = computed(() =>
    this.ratingsDocuments()
      .filter(doc => TopLevelCategoryRanks.includes(doc.rank))
      .sort((a, b) => a.rank - b.rank)
      .map(doc => ({
        value: doc?.custom_rating_number ?? doc?.rating_number,
        label: doc?.category_tag,
        rank: doc?.rank,
        categoryId: doc?.horizon_category_id
      }))
  );
  readonly categoriesForOverview = computed(() =>
    this.ratingsDocuments()
      .filter(doc => CategoryRanksForOverview.includes(doc.rank))
      .sort((a, b) => a.rank - b.rank)
      .map(doc => ({
        value: doc?.custom_rating_number ?? doc?.rating_number,
        label: doc?.category_tag,
        rank: doc.rank,
        categoryId: doc?.horizon_category_id
      }))
  );
  readonly isExpandedViewActive = this.store.selectSignal(HorizonRatingsFeature.selectIsExpandedViewActive);
  readonly ratingsDocuments = this.store.selectSignal(HorizonRatingsFeature.selectRatingsDocuments);
  readonly loading = this.store.selectSignal(HorizonRatingsFeature.selectLoading);
  readonly error = this.store.selectSignal(HorizonRatingsFeature.selectError);

  loadRatingsDocuments(datasetUId: string, selectedOverviewDocument: Document): void {
    this.store.dispatch(HorizonRatingsActions.loadRatingsDocuments({ datasetUId, selectedOverviewDocument }));
  }

  showExpandedView(datasetUId: string, selectedOverviewDocument: Document, loadRatingsDocuments: boolean): void {
    this.store.dispatch(HorizonRatingsActions.showExpandedView({ datasetUId, selectedOverviewDocument, loadRatingsDocuments }));
  }

  hideExpandedView(): void {
    this.store.dispatch(HorizonRatingsActions.hideExpandedView());
  }

  resetState(): void {
    this.store.dispatch(HorizonRatingsActions.resetState());
  }
}
